var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":_vm.modalId,"hide-footer":"","size":_vm.size},on:{"hidden":_vm.onClose},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_c('h3',{staticClass:"text-2xl mb-0 font-medium"},[_vm._v(_vm._s(_vm.title))])]},proxy:true}])},[_c('div',{staticClass:"block"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }